import { createFileRoute } from '@tanstack/react-router'
import { SignUpForm } from '@/features/authentication/components/signup-form'

export const Route = createFileRoute('/signup')({

  component: Signup,
})

function Signup() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <SignUpForm />
      </div>
    </div>
  )
}
